// Modal logic extracted from header.js
export let openMenu = null;
let preventOutsideClick = false;

function getSlideClasses(direction) {
    if (direction === "right") {
        return {
            hide: "translate-x-full",
            show: "translate-x-0",
            remove: ["-translate-x-full", "translate-x-full", "translate-y-full"],
        };
    } else if (direction === "bottom") {
        return {
            hide: "translate-y-full",
            show: "translate-y-0",
            remove: ["-translate-x-full", "translate-x-full", "translate-y-full"],
        };
    } else {
        // default left
        return {
            hide: "-translate-x-full",
            show: "translate-x-0",
            remove: ["-translate-x-full", "translate-x-full", "translate-y-full"],
        };
    }
}

export function openElement(targetId, triggerButton = null) {
    const target = document.getElementById(targetId);
    if (!target) return;

    // Retrieve the backdrop selector from the data attribute.
    const backdropSelector = target.dataset.modalBackdrop;
    const backdropElement = backdropSelector ? document.querySelector(backdropSelector) : null;

    // Slide direction logic
    const slideDirection = target.dataset.modalSlide || "left";
    const slideClasses = getSlideClasses(slideDirection);
    target.classList.remove(...slideClasses.remove);
    target.classList.add(slideClasses.hide);

    openMenu = target;
    preventOutsideClick = true; // Prevent immediate closing
    window.fgtModalOpen = true; // Set global modal open flag

    target.classList.remove("hidden");
    if (backdropElement) {
        backdropElement.classList.remove("hidden");
    }

    requestAnimationFrame(() => {
        target.classList.remove("opacity-0");
        target.classList.remove(slideClasses.hide);
        target.classList.add(slideClasses.show);
        if (backdropElement) {
            backdropElement.classList.remove("opacity-0");
        }
    });

    document.body.classList.add("overflow-hidden");

    // Accessibility: set aria attributes
    if (triggerButton) {
        triggerButton.setAttribute("aria-expanded", "true");
    }
    target.setAttribute("aria-expanded", "true");
    target.setAttribute("aria-modal", "true");
    target.setAttribute("role", "dialog");

    // Focus management
    const focusSelector = target.dataset.setFocus;
    if (focusSelector) {
        const focusTarget = document.querySelector(focusSelector);
        if (focusTarget) {
            setTimeout(() => focusTarget.focus(), 350);
        }
    } else {
        setTimeout(() => target.focus(), 350);
    }

    // Wait for animation to complete before allowing outside clicks
    setTimeout(() => {
        preventOutsideClick = false;
        // Dispatch custom event after modal is open
        const event = new CustomEvent("fgt:modal:opened", {
            detail: { id: targetId, element: target },
        });
        document.dispatchEvent(event);
    }, 300);

    // Add event listeners only when the menu is open
    if (target.dataset.preventClose === "true") return;
    document.addEventListener("click", handleOutsideClick);
    document.addEventListener("keydown", handleEscapeKey);
}

export function closeElement(targetId) {
    const target = document.getElementById(targetId);
    if (!target) return;

    // Retrieve the backdrop selector from the data attribute.
    const backdropSelector = target.dataset.modalBackdrop;
    const backdropElement = backdropSelector ? document.querySelector(backdropSelector) : null;

    // Slide direction logic
    const slideDirection = target.dataset.modalSlide || "left";
    const slideClasses = getSlideClasses(slideDirection);
    target.classList.remove(slideClasses.show);
    target.classList.add(slideClasses.hide);
    target.classList.add("opacity-0");
    if (backdropElement) {
        backdropElement.classList.add("opacity-0");
    }

    setTimeout(() => {
        target.classList.add("hidden");
        if (backdropElement) {
            backdropElement.classList.add("hidden");
        }
        document.body.classList.remove("overflow-hidden");
        openMenu = null;
        window.fgtModalOpen = false; // Unset global modal open flag

        // Accessibility: set aria attributes
        target.setAttribute("aria-expanded", "false");
        target.setAttribute("aria-modal", "false");

        // Focus management: return focus to toggle button if specified
        const returnFocusSelector = target.dataset.setFocus;
        if (returnFocusSelector) {
            const returnFocusTarget = document.querySelector(returnFocusSelector);
            if (returnFocusTarget) {
                setTimeout(() => returnFocusTarget.focus(), 100);
            }
        }

        // Dispatch custom event after modal is closed
        const event = new CustomEvent("fgt:modal:closed", {
            detail: { id: targetId, element: target },
        });
        document.dispatchEvent(event);

        if (target.dataset.preventClose === "true") return;
        // Remove event listeners when the menu is closed
        document.removeEventListener("click", handleOutsideClick);
        document.removeEventListener("keydown", handleEscapeKey);
    }, 300);
}

function handleOutsideClick(event) {
    if (preventOutsideClick) return;
    const backdropSelector = openMenu?.dataset.modalBackdrop;
    const backdropElement = backdropSelector ? document.querySelector(backdropSelector) : openMenu;

    // If the click occurred directly on the backdrop (openMenu), close it.
    if (openMenu && event.target === backdropElement) {
        closeElement(openMenu.id);
    }
}

function handleEscapeKey(event) {
    if (event.key === "Escape" && openMenu) {
        closeElement(openMenu.id);
    }
}

export function modalInit() {
    const toggleButtons = document.querySelectorAll("[data-modal-toggle]");
    const closeButtons = document.querySelectorAll("[data-modal-close]");

    toggleButtons.forEach((button) => {
        button.addEventListener("click", () => {
            const targetId = button.getAttribute("data-modal-toggle");
            openElement(targetId, button);
        });
    });

    closeButtons.forEach((button) => {
        button.addEventListener("click", () => {
            const targetId = button.getAttribute("data-modal-close");
            closeElement(targetId);
        });
    });

    if (typeof jQuery !== "undefined") {
        jQuery(document.body).on("added_to_cart", function () {
            openElement("fgt-mini-cart-drawer");
        });
    }
}
